export class ApplicationConstant {
    static doNotEscalate = 'Do Not Escalate';
    static doNotNotify = 'Do Not Notify';
    static individual = 'INDIVIDUAL';
    static group = 'GROUP';
    static device = 'DEVICE';
    static globalEscalation = 2;

    static admin = 'ROLE_alerting-admin';
    private static _adminOn = true;

    static getAdminRole() {
        return ApplicationConstant._adminOn ? ApplicationConstant.admin : 'ADMIN_OFF';
    }

    static toggleAdminRole(isOn: boolean) {
        ApplicationConstant._adminOn = isOn;
        return ApplicationConstant._adminOn;
    }
}
